module.exports = __webpack_public_path__ + "static/media/bookings.894e52ca.jpg";